// extracted by mini-css-extract-plugin
export default {"tripleSpinnerContainer":"loader_tripleSpinnerContainer__cmqbu","tripleSpinner":"loader_tripleSpinner__49IXk","spin":"loader_spin__gJ9VG"};